import { gql } from '@/features/graphql/generated'

export const SelectedCategoryQuery = gql(/* GraphQL */ `
    query SelectedCategory($id: ID) {
        category(uuid: $id) {
            ...SelectedCategory
            subcategories {
                ...SelectedCategory
            }
        }
    }
`)
